<template>
  <div class="code-input">
    <div class="flex items-center justify-center">
      <img :src="src" alt="验证码" height="60" />
      <span class="text-theme cursor-pointer ml-5" @click="$emit('refresh')">刷新</span>
    </div>
    <input type="text" ref="input" @input="onInput" @blur="onBlurHandler" class="h-0" />
    <div class="" @click="onFocus">
      <ul class="code-input__wrap relative">
        <li
          class="code-input__item text-center"
          v-for="(item, idx) in values"
          :key="idx"
          :class="{ 'code-input__focus': idx === activeIndex }"
        >
          <span>{{ item }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CodeInput',
  props: {
    src: {
      type: String,
      required: true
    },
    len: {
      type: Number,
      default: 4
    }
  },
  data() {
    return {
      activeIndex: 0,
      values: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.values = new Array(this.len)
    },
    onFocus() {
      this.$refs.input.focus()
      this.activeIndex = this.values.filter(Boolean).length
    },
    onInput(event) {
      let value = event.target.value
      let vals = value.split('').filter(x => x.toString().trim())
      let flag = true
      for (let i = 0; i < this.values.length; i++) {
        if (vals[i]) {
          this.values[i] = vals[i]
        } else {
          this.values[i] = ''
          flag = false
          this.activeIndex = i
          break
        }
      }
      if (flag) {
        let val = this.values.join('')
        this.activeIndex = -1
        event.target.value = val
        this.$emit('finished', val)
      }
      this.values.__ob__.dep.notify()
    },
    clear() {
      this.init()
    },
    onBlurHandler() {
      this.$refs.input.focus()
    }
  },
  mounted() {
    this.$refs.input.focus()
  }
}
</script>

<style scoped lang="scss">
.code-input {
  position: relative;
  margin: 0 20px;
  user-select: none;

  &__wrap {
    display: flex;
    width: 100%;
    height: 50px;
    cursor: pointer;
  }

  &__item {
    @apply relative flex justify-center flex-1 items-center h-full text-20;
    line-height: 1.2;
  }

  &__item {
    border: 1px solid #f2f5fa;
    @apply rounded-medium mr-3;

    &:last-child {
      margin-right: 0;
    }
  }

  .code-input__focus {
    @apply border-theme;
    &::after {
      content: ' ';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1px;
      height: 40%;
      background-color: #323233;
      transform: translate(-50%, -50%);
      animation: 1s dy-cursor-flicker infinite;
    }
  }
}
</style>
